// extracted by mini-css-extract-plugin
export var active = "_mv-2";
export var recordingDot = "_mv-1";
export var recordingIndicator = "_mv-0";